import { render, staticRenderFns } from "./ProjectOwnerRequestInvitation.vue?vue&type=template&id=e9056dc0"
import script from "./ProjectOwnerRequestInvitation.vue?vue&type=script&lang=ts"
export * from "./ProjectOwnerRequestInvitation.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOwnerRequestInvitation.vue?vue&type=style&index=0&id=e9056dc0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports